// D-068: the blue verified tick (Adyvance approved the shop's business verification). An original
// 12-point seal in the primary blue with its on-colour check (both themes). It carries its own
// accessible name, since it is information, not decoration; pass `label` (from the catalogue).

// The seal: 24 points alternating between two radii around (12, 12), rounded by a matching stroke.
const SEAL = Array.from({ length: 24 }, (_, i) => {
  const a = (i * Math.PI) / 12 - Math.PI / 2;
  const r = i % 2 === 0 ? 10.2 : 8.6;
  return `${(12 + r * Math.cos(a)).toFixed(2)} ${(12 + r * Math.sin(a)).toFixed(2)}`;
}).join(" L");

/** `unverified`: the same seal in grey with a dash (not verified yet), for tight spaces. */
export function VerifiedTick({
  label,
  className,
  unverified = false,
}: {
  label: string;
  className?: string;
  unverified?: boolean;
}) {
  const seal = unverified
    ? "var(--ady-color-border-control)"
    : "var(--ady-color-action-primary-bg)";
  return (
    <svg
      viewBox="0 0 24 24"
      role="img"
      aria-label={label}
      className={className ? `ady-verified ${className}` : "ady-verified"}
      style={{ width: "var(--ady-icon-size)", height: "var(--ady-icon-size)", flex: "none" }}
      data-testid={unverified ? "unverified-tick" : "verified-tick"}
    >
      <title>{label}</title>
      <path
        d={`M${SEAL}Z`}
        fill={unverified ? "var(--ady-color-bg-sunken)" : seal}
        stroke={seal}
        strokeWidth={1.6}
        strokeLinejoin="round"
      />
      <path
        d={unverified ? "M8.5 12h7" : "M8 12.3l2.7 2.7L16.2 9.5"}
        fill="none"
        stroke={unverified ? seal : "var(--ady-color-action-primary-fg)"}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
